
const initial = {
    userProfileType: '',
    users: '',
    messages:'',
    current_user:'',
    sender_id:'',
    receiver_id:'',
    notificationHeader: [],
    userFollows: [],
    publicationType: null,
    userRole: null,
    userData: {
        id: null,
        name: null,
        avatar: null,
        about: null,
        is_verified: null,
        phone: null,
        email: null,
        organization: null,
        loyalty_level: null,
        role: null,
        roles: [],
        city: null,
        need_review: null,
        settings: {
            display_phone: 0,
            display_email: 0,
        },
        switch_role_abilities: {
            donator_basic: null,
            volunteer: null,
            zooprotection_org_owner: null,
        },
        facilities_counts:{
            auto_help: null,
            giveaway: null,
            homestay: null,
            photo_help: null,
            pr_help: null
        }
    },

    appRoutes: window.appRoutes,
}

const getDefault = () => ({ ...initial });

const state = getDefault();

const getters = {
    loggedIn: state => Boolean(state.userData.id),
    getUserData: state => {
        return state.userData;
    },
    getUserName: state => {
        return state.userData.name;
    },
    getUserAvatar: state => {
        return state.userData.avatar;
    },
    getUserAbout: state => {
        return state.userData.about;
    },
    getDisplayPhone: state => {
        return state.userData.settings.display_phone;
    },
    getDisplayEmail: state => {
        return state.userData.settings.display_email;
    },
    getIsVerified: state => {
        return state.userData.is_verified;
    },

    getUserCity: state => {
        return state.userData.city;
    },

    getUserRoles: state => {
        return state.userData.roles;
    },
    getUserRole: state => {
        return state.userData.role;
    },
    getNotifications: state => {
        return state.notificationHeader
    },

    getFacilities: state => {
        return state.userData.facilities_counts
    },

    getFollows: state => {
        return state.userFollows
    },

    getUserProfileType: state => {
        return state.userProfileType
    },

    getUserLoyalty: state => {
        return state.userData.loyalty_level
    },

    getPublicationType: state => {
        return state.publicationType
    }

};

const mutations = {
    get_users(state, data){
        state.users = data
    },
    get_messages(state, data){
        state.messages = data
    },
    get_current_user(state, data){
        state.current_user = data
    },
    get_receiver_id(state, data){
        state.receiver_id = data
    },
    get_sender_id(state, data){
        state.sender_id = data
    },
    setUserData(state, payload) {
        state.userData = payload;
    },
    setUserName(state, payload) {
        state.userData.name = payload;
    },
    setUserNeedReview(state, payload) {
        state.userData.need_review = payload;
    },
    setUserAvatar(state, payload) {
        state.userData.avatar = payload;
    },
    setUserAbout(state, payload) {
        state.userData.about = payload;
    },
    setDisplayPhone(state, payload) {
        state.userData.settings.display_phone = payload;
    },
    setDisplayEmail(state, payload) {
        state.userData.settings.display_email = payload;
    },
    setIsVerified(state, payload) {
        state.userData.is_verified = payload;
    },

    setUserCity(state, payload) {
        state.userData.city = payload;
    },

    setUserRoles(state, payload) {
        state.userData.roles = payload;
    },

    setUserRole(state, payload) {
        state.userData.role = payload;
    },

    setNotifications(state, data){
        state.notificationHeader = data
    },

    setFacilities(state, data){
        state.userData.facilities_counts = data
    },
    setFollows(state, data){
        state.userFollows = data
    },

    setUserProfileType(state, data){
        state.userProfileType = data
    },

    setPublicationType(state, data){
        state.publicationType = data
    }
};

const actions = {

    Fetchuser({commit}){
        axios.get(window.location.origin+'/getuser',{

            }
        ).then(response=>{
            commit('get_users',response.data.data)
        })
    },

    getChat({commit},data){
        axios.get(window.location.origin+'/getchat/'+data.id, {
            }
        ).then(response=>{
            commit('get_messages',response.data.data.message)
            commit('get_receiver_id',data.id)
            commit('get_sender_id',data.sender_id)
            commit('get_current_user',response.data.data.user)


        })
    },

    loadUserDataFromServer(context, payload) {
        let store = this;
        axios.get('/api/user/data')
            .then(response => {
                if (response.data.success) {
                    if (response.data.data) {
                        context.commit('setUserData', {...response.data.data, role: null});

                        return context

                    } else {
                        context.commit('setUserData', '');
                    }
                }
            })
            .then((context) => {

                let defaultRoles = ['zooprotection_org_owner', 'volunteer', 'donator_basic'],
                    roleDefault  = context.getters.getUserRoles
                        .map(role => role.name)
                        .find(role => defaultRoles.indexOf(role) >= 0);

                if(!roleDefault){
                    return  context.commit('setUserRole', null)
                }

                context.commit('setUserRole', roleDefault)

            })
            .catch(error => {
                error = error.response.data

                if(!error.success){
                    context.commit('setUserData', '');
                }

            })

    },

    fetchNotifications({commit}){

        let url = '/api/notifications-unread';

        axios.get(url)
            .then(response => {

                commit('setNotifications', response.data.data)

            })
            .catch((error) => {

            });


    },

    readNotifications({dispatch}, id){


        let url = '/api/notifications-set-read';
        if (confirm('Read?'))
            axios.put(url, {
                ids : [id ]
            })
                .then(response => {
                    alert(response.data.message)
                })
                .catch((error) => {

                })
                .then(()=>{
                    dispatch('fetchNotifications')
                });


    },
    fetchFollows({commit}, request = {}){
        axios
            .get(`/api/user/follows`,{params: {per_page: 50, ...request}})
            .then(response => {
                response = response.data

                if(response.success){
                    commit('setFollows', response.data)

                }

            })
            .catch(error => {
                error = error.response.data

                if(!error.success) console.log(error)

            })

    }

};

export default {
    state,
    getters,
    mutations,
    actions,
}
